(function ($) {
   var $sticky = $('.new-header');
   var stickyTop = $sticky.offset().top;
   var stickyHeight = $sticky.outerHeight();
   // var prevScrollTop = $(window).scrollTop();
   var prevScrollTop = 0;
   var mobileMenuVisible = false;

   function checkMobileMenuVisible() {
      if ($('.mobile-header').is(':visible')) {
         mobileMenuVisible = true;
      } else {
         mobileMenuVisible = false;
      }

      // console.log('mobileMenuVisible: %o', mobileMenuVisible);
   }

   $(window).on('resize', $.debounce(100, checkMobileMenuVisible));

   $(window).on(
      'scroll',
      // $.throttle(40, function () {
      function () {
         var scrollTop = $(this).scrollTop();
         var scrollingDown = scrollTop > prevScrollTop;
         // stickyTop = $sticky.offset().top;
         // stickyHeight = $sticky.outerHeight();
         var offset = mobileMenuVisible ? stickyTop : stickyTop + stickyHeight;

         // console.log('mobileMenuVisible: %o', mobileMenuVisible);

         // console.log('scrollTop: %o, prevScroll: %o', scrollTop, prevScrollTop);

         // Element is "stuck" when you scroll past its top
         if (scrollTop >= stickyTop) {
            // After element top

            // "hide" when scrolled past the entire element (not visible at all)
            // $sticky.addClass('sticky--stuck');

            if (scrollTop >= offset) {
               // After element
               // $sticky.removeClass('sticky--normalize');

               if (scrollingDown) {
                  // console.log('stuck');
                  $sticky.removeClass('sticky--show');
                  $sticky.addClass('sticky--hide sticky--stuck');
                  // } else if ($sticky.hasClass()) {
               } else {
                  // console.log('un stuck');
                  // Up
                  $sticky.removeClass('sticky--hide');
                  $sticky.addClass('sticky--show sticky--animate');
               }
            } else {
               // Within element
               // $sticky.removeClass('sticky--stuck sticky--hide');
               // $sticky.removeClass('sticky--stuck');
               // if (!$sticky.hasClass('sticky--stuck')) {
               //    if (scrollingDown) {
               //    } else {
               //       console.log('within element scrolling up');
               //       // Up
               //       // $sticky.removeClass('sticky--show sticky--animate sticky--hide');
               //       $sticky.addClass('sticky--normalize');
               //    }
               // }
            }
         } else {
            // Before element top
            // $sticky.removeClass('sticky--stuck sticky--show sticky--animate sticky--normalize');
            $sticky.removeClass('sticky--stuck sticky--show sticky--animate');
         }
         prevScrollTop = scrollTop;
         // })
      }
   );

   checkMobileMenuVisible();
})(jQuery);
